export const USER_MULTI_VALUE_AVATAR_SIZE = 24
